// extracted by mini-css-extract-plugin
export default {"Grid":"index-module_Grid_eMGBN","container":"index-module_container_h74bk"};